// import { LinkageSystemConst } from "@src/constants/LinkageSystemConst";
import { pageType } from "../types/pageType";
// import { routeConst } from "@src/types/routes";

const home: pageType = {
  href: "https://www.daiwa.jp/",
  name: "ホーム",
  primaryIcon: "/img/logo.png",
  secondaryIcon: "",
  iconAlt: "大和証券 Daiwa Securities",
};

const accountBeforeConfirm: pageType = {
  href: "/account-before-confirm",
  name: "お申込み前のご確認",
  primaryIcon: "",
  secondaryIcon: "",
};

const accountTermsConfirm: pageType = {
  href: "/account-terms-confirm",
  name: "取引約款・規定等の確認",
  primaryIcon: "",
  secondaryIcon: "",
};

const simpleKozaReq: pageType = {
  href: "/simple-koza-req",
  name: "メールアドレスの登録",
  primaryIcon: "",
  secondaryIcon: "",
};

const simpleMailFinish: pageType = {
  href: "/simple-mail-finish",
  name: "メールアドレスの登録完了",
  primaryIcon: "",
  secondaryIcon: "",
};

const privacyPolicy: pageType = {
  href: "https://www.daiwa.jp/policy/privacy/",
  name: "プライバシーポリシー",
  primaryIcon: "",
  secondaryIcon: "",
};

const purposeOfUse: pageType = {
  href: "https://www.daiwa.jp/policy/privacy/purpose_priv.html",
  name: "個人情報の利用目的",
  primaryIcon: "",
  secondaryIcon: "",
};

const pageNotFound: pageType = {
  href: "/page-not-found",
  name: "",
  primaryIcon: "",
  secondaryIcon: "",
};

const digitalauthenticationguidance: pageType = {
  href: "/digital-authentication-guidance",
  name: "マイナンバーカードで本人確認",
  primaryIcon: "",
  secondaryIcon: "",
};

const AccountRegisterForm: pageType = {
  href: "/account-register-form",
  name: "口座開設の申込み",
  primaryIcon: "",
  secondaryIcon: "",
};

const VariousServicePinEntry: pageType = {
  href: "/various-service-pin-entry",
  name: "各種サービス・暗証番号の登録",
  primaryIcon: "",
  secondaryIcon: "",
};

const daiwaNextApply: pageType = {
  href: "/daiwa-next-apply",
  name: "大和ネクスト銀行口座開設",
  primaryIcon: "",
  secondaryIcon: "",
};

const customerCardInput: pageType = {
  href: "/customer-card-input",
  name: "お客様カードの入力",
  primaryIcon: "",
  secondaryIcon: "",
};

const AccountOpeningConfirm: pageType = {
  href: "/account-opening-confirm",
  name: "口座開設の申込み確認",
  primaryIcon: "",
  secondaryIcon: "",
};

const AccountOpeningComplete: pageType = {
  href: "/account-opening-complete",
  name: "口座開設完了",
  primaryIcon: "",
  secondaryIcon: "",
};

const mynumberGuide: pageType = {
  href: "/mynumber/guide",
  name: "マイナンバー登録ガイド",
  primaryIcon: "",
  secondaryIcon: "",
};

const mynumberLogin: pageType = {
  href: "/mynumber/login",
  name: "マイナンバーログイン",
  primaryIcon: "",
  secondaryIcon: "",
};

const mynumberSubmitResult: pageType = {
  href: "/mynumber/submit-result",
  name: "マイナンバー届出状況",
  primaryIcon: "",
  secondaryIcon: "",
};

const mynumberAlreadyRegistered: pageType = {
  href: "/mynumber/already-registered",
  name: "マイナンバー登録済み",
  primaryIcon: "",
  secondaryIcon: "",
};

const digitalIdentifyVertification: pageType = {
  href: "/digital/identify-vertification",
  name: "マイナンバーカードでマイナンバー登録",
  primaryIcon: "",
  secondaryIcon: "",
};

const mynumberRegisterConfirm: pageType = {
  href: "/mynumber/register-confirm",
  name: "マイナンバー登録確認",
  primaryIcon: "",
  secondaryIcon: "",
};

const mynumberRegisterError: pageType = {
  href: "/mynumber/register-error",
  name: "マイナンバー登録エラー",
  primaryIcon: "",
  secondaryIcon: "",
};

const mynumberRegisterComplete: pageType = {
  href: "/mynumber/register-complete",
  name: "マイナンバー登録完了",
  primaryIcon: "",
  secondaryIcon: "",
};

const error: pageType = {
  href: "/error",
  name: "",
  primaryIcon: "",
  secondaryIcon: "",
};

export const mailFlowUrls = [
  accountBeforeConfirm,
  accountTermsConfirm,
  simpleKozaReq,
  simpleMailFinish,
];

export const IdentityVerificationFlowUrls = [
  digitalauthenticationguidance,
  AccountRegisterForm,
  VariousServicePinEntry,
  daiwaNextApply,
  customerCardInput,
  AccountOpeningConfirm,
  AccountOpeningComplete,
];

export const mynumberFlowUrls = [
  mynumberGuide,
  mynumberLogin,
  mynumberSubmitResult,
  mynumberAlreadyRegistered,
  digitalIdentifyVertification,
  mynumberRegisterConfirm,
  mynumberRegisterError,
  mynumberRegisterComplete,
];

export const pageConst = {
  home,
  accountBeforeConfirm,
  accountTermsConfirm,
  simpleKozaReq,
  simpleMailFinish,
  privacyPolicy,
  purposeOfUse,
  pageNotFound,
  daiwaNextApply,
  customerCardInput,
  digitalauthenticationguidance,
  AccountRegisterForm,
  AccountOpeningConfirm,
  AccountOpeningComplete,
  VariousServicePinEntry,
  mynumberGuide,
  error,
  mynumberLogin,
  mynumberSubmitResult,
  mynumberAlreadyRegistered,
  digitalIdentifyVertification,
  mynumberRegisterConfirm,
  mynumberRegisterError,
  mynumberRegisterComplete,
};
